import React from "react";
import { Routes, Route } from "react-router-dom";

import LandingPage from "../landing-page";

const PublicLayout = () => {
  return (
    <div className="h-full">
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </div>
  );
};

export default PublicLayout;
